import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Lock, Mail, Copy } from 'lucide-react';

const TEST_CREDENTIALS = [
  { role: 'Admin',            email: 'admin@bhavya.com',    password: 'Admin@123' },
  { role: 'Production Manager',email: 'plantmgr@bhavya.com',password: 'Manager@123' },
  { role: 'QA Head',          email: 'qa@bhavya.com',       password: 'QA@123' },
  { role: 'QC Analyst',       email: 'qc@bhavya.com',       password: 'QC@123' },
  { role: 'Shop-floor Operator',email: 'operator@bhavya.com',password: 'Operator@123' },
];

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'var(--bg-page)',
        backgroundImage: 'url(https://images.unsplash.com/photo-1663497653290-1b8f327096f7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxtaW5pbWFsJTIwYWJzdHJhY3QlMjBnZW9tZXRyaWMlMjBiYWNrZ3JvdW5kJTIwd2hpdGUlMjBncmV5fGVufDB8fHx8MTc3NTY0NDQ2N3ww&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      data-testid="login-page"
    >
      <div
        className="card"
        style={{
          width: '100%',
          maxWidth: '460px',
          margin: '0 16px',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          {/* <h1 style={{ fontSize: '28px', fontWeight: 900, margin: 0 }}>ERP System</h1> */}
          <img src='https://hridya.dweb.co.in/hridayalogo.png' alt='logo' style={{width:'110px', height:'auto', margin:'0 auto', display:'block'}} />
          <p style={{ color: 'var(--text-secondary)', marginTop: '8px', fontSize: '14px' }}>
            Sign in to your account
          </p>
        </div>

        {error && (
          <div
            style={{
              padding: '12px',
              backgroundColor: '#FEE2E2',
              border: '1px solid #F87171',
              borderRadius: '4px',
              color: '#991B1B',
              marginBottom: '20px',
              fontSize: '13px',
            }}
            data-testid="login-error"
          >
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} data-testid="login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              <Mail size={14} style={{ display: 'inline', marginRight: '4px' }} />
              Email
            </label>
            <input
              id="email"
              type="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@bhavya.com"
              data-testid="email-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password">
              <Lock size={14} style={{ display: 'inline', marginRight: '4px' }} />
              Password
            </label>
            <input
              id="password"
              type="password"
              className="form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter your password"
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%', marginTop: '8px' }}
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div
          style={{
            marginTop: '24px',
            padding: '14px 16px',
            backgroundColor: 'var(--bg-surface-alt)',
            borderRadius: '4px',
            fontSize: '12px',
          }}
          data-testid="test-credentials"
        >
          <div style={{ fontWeight: 700, marginBottom: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Test Credentials</span>
            <span style={{ fontSize: '10px', fontWeight: 500, color: 'var(--text-tertiary)' }}>click a row to autofill</span>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border-default)' }}>
                <th style={{ textAlign: 'left',  padding: '4px 6px', fontSize: '10px', textTransform: 'uppercase', color: 'var(--text-tertiary)' }}>Role</th>
                <th style={{ textAlign: 'left',  padding: '4px 6px', fontSize: '10px', textTransform: 'uppercase', color: 'var(--text-tertiary)' }}>Email</th>
                <th style={{ textAlign: 'left',  padding: '4px 6px', fontSize: '10px', textTransform: 'uppercase', color: 'var(--text-tertiary)' }}>Password</th>
                <th style={{ width: 24 }}></th>
              </tr>
            </thead>
            <tbody>
              {TEST_CREDENTIALS.map((c) => (
                <tr
                  key={c.email}
                  onClick={() => { setEmail(c.email); setPassword(c.password); setError(''); }}
                  style={{ cursor: 'pointer', borderBottom: '1px solid var(--border-default)' }}
                  data-testid={`cred-row-${c.role.toLowerCase().replace(/[\s/-]/g, '-')}`}
                  title="Click to autofill"
                >
                  <td style={{ padding: '6px', fontWeight: 600 }}>{c.role}</td>
                  <td style={{ padding: '6px', fontFamily: 'monospace' }}>{c.email}</td>
                  <td style={{ padding: '6px', fontFamily: 'monospace' }}>{c.password}</td>
                  <td style={{ padding: '6px', textAlign: 'right', color: 'var(--text-tertiary)' }}>
                    <Copy size={12} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '8px', fontSize: '10px', color: 'var(--text-tertiary)' }}>
            For demo / dev use only — remove before production.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
